"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError_bff = void 0;
var tslib_1 = require("tslib");
/* eslint-disable  @typescript-eslint/camelcase */
var index_1 = require("../../authorize/index");
var index_2 = require("../../common/index");
var index_3 = require("../index");
var index_4 = require("../../authorize/index");
var logError_bff = function (error, internalRequestPayload) {
    /* istanbul ignore next */
    var refererUrl = (0, index_3.getRefererUrl)(internalRequestPayload === null || internalRequestPayload === void 0 ? void 0 : internalRequestPayload.pageUrl);
    var eventType = error.errorMessage === "Order Placed successfully" ? "SUCCESS" : "FAILURE";
    eventType = error.nrEventType ? error.nrEventType : eventType;
    var errorData = {
        input: {
            fields: tslib_1.__assign(tslib_1.__assign({}, error), { applicationKey: index_1.authorizeParams.apiKey, refererUrl: refererUrl, endgameExperimentAllocation: index_4.endgameExperimentAllocation }),
            eventType: eventType
        }
    };
    try {
        (0, index_2.sendBFFCall)("logFECheckoutEvent", errorData, undefined, undefined, undefined, internalRequestPayload, false);
    }
    catch (_err) {
        /* istanbul ignore next */
        return; // shouldn't throw an error, what will they do, log it?  ;)
    }
    return true;
};
exports.logError_bff = logError_bff;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/newRelic/bff/index.js
// module id = 3408
// module chunks = 11